import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import DingtalkSquareFilledSvg from "@ant-design/icons-svg/es/asn/DingtalkSquareFilled";
import AntdIcon from "../components/AntdIcon";
var DingtalkSquareFilled = function DingtalkSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DingtalkSquareFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  DingtalkSquareFilled.displayName = 'DingtalkSquareFilled';
}
export default /*#__PURE__*/React.forwardRef(DingtalkSquareFilled);